import { useSelector } from 'react-redux'

import { digObject, sortArrayBy, toggleArray } from '@domain-group/javascript-utils'

import { useSetState } from '@domain-group/react-hooks'

import useServiceProduct from '@hooks/useServiceProduct'

const togglePublicationId = (id, selectedPublicationIds, setState) => {
  if (!id) return

  const updatedPublicationIds = toggleArray(selectedPublicationIds, id)
  setState({ selectedPublicationIds: updatedPublicationIds })
}

const useManageServiceProductPublicationsModal = (serviceProduct, optionsKey) => {
  const {
    callbacks: {
      updateServiceProduct,
    },
  } = useServiceProduct(serviceProduct)

  const publicationIds = digObject(serviceProduct, `options.${optionsKey}.compatible_publications`, [])

  const [state, setState] = useSetState({ selectedPublicationIds: publicationIds })
  const { selectedPublicationIds } = state

  const publications = useSelector(reduxState => reduxState.entities.publications)

  const selectedPublications = selectedPublicationIds
    .map(id => publications[id])
    .filter(publication => publication)

  const sortedPublications = sortArrayBy(selectedPublications, 'asc', 'title')

  const hasSelectedPublications = !!selectedPublications.length

  const serviceProductParams = {
    options: {
      [optionsKey]: {
        compatible_publications: selectedPublicationIds,
      },
    },
  }

  return {
    callbacks: {
      togglePublicationId: id => togglePublicationId(id, selectedPublicationIds, setState),
      updateServiceProduct,
    },
    hasSelectedPublications,
    selectedPublicationIds,
    serviceProductParams,
    sortedPublications,
  }
}

export default useManageServiceProductPublicationsModal
